"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Base = require("../common/Base");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["platform", "type", "base", "user", "repo", "query"];
var Analysis = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _props$platform = props.platform,
    platform = _props$platform === void 0 ? 'github' : _props$platform,
    _props$type = props.type,
    type = _props$type === void 0 ? 'languages-count' : _props$type,
    _props$base = props.base,
    base = _props$base === void 0 ? 'https://img.shields.io' : _props$base,
    user = props.user,
    repo = props.repo,
    query = props.query,
    other = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var getUrl = function getUrl() {
    var typePath = '';
    switch (type) {
      case 'languages-count':
        typePath = 'languages/count';
        break;
      case 'languages-top':
        typePath = 'languages/top';
        break;
      case 'search':
        typePath = 'search';
        break;
      default:
        break;
    }
    if (platform !== 'github' || !typePath) return '';
    var baseData = [base, platform, typePath, user, repo];
    if (query) {
      return [].concat(baseData, [query]).join('/');
    }
    return baseData.join('/');
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Base.Internal, (0, _objectSpread2["default"])({
    imgSrc: getUrl(),
    ref: ref
  }, other));
});
Analysis.displayName = 'Analysis';
var _default = exports["default"] = Analysis;
module.exports = exports.default;